import config from 'config';
import { memStore, persistentStore } from 'services/storage';

const authHeaders = () => memStore.get('apiAuthHeaders');
const userToken = () => persistentStore.get('user-token');

const bodyText = (body) => body && JSON.stringify(body);

export async function doFetch(url, method, { headers, body }) {
  const response = await fetch(`${config.baseURL}${url}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      pragma: 'no-cache',
      'cache-control': 'no-cache',
      platform: 'web',
      'X-Web-Version': '1200',
      Connection: 'Keep-Alive',
      ...authHeaders(),
      ...userToken(),
      ...headers,
    },
    body,
  });

  if (!response.ok) {
    return {
      error: {
        userMessage: 'Something went wrong!',
      },
    };
  }

  const dataResponse = await response.json();
  return dataResponse;
}

export const apiFetch = doFetch;

function withQueryString(url, query) {
  const questionMark = !!query && url.indexOf('?') < 0 ? '?' : '';
  const queryString = new URLSearchParams(query).toString(); // returns '' for undefined or {}
  return `${url}${questionMark}${queryString}`;
}

export async function apiGet(url, { headers, query } = {}) {
  return doFetch(withQueryString(url, query), 'GET', { headers });
}

export async function apiPost(url, { headers, body }) {
  return doFetch(url, 'POST', { headers, body: bodyText(body) });
}

export async function apiPut(url, { headers, body }) {
  return doFetch(url, 'PUT', { headers, body: bodyText(body) });
}

export async function apiDelete(url, { headers } = {}) {
  return doFetch(url, 'DELETE', { headers });
}

export async function getDirect(url) {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(
      `Error Response: ${response.status} ${response.statusText}`
    );
  }
  return response.json();
}
